(function (app) {

    app.provider("onboardingApi",
        [
            function () {
                this.$get = [
                    "portalApiGateway", function (portalApiGateway) {
                        var service = {};

                        //gets                                        
                        service.getUsersArcInfo = function() {
                            return portalApiGateway.get("/UserOnboarding/ArcInfo");
                        };

                        service.getLoggedInUserOnboarding = function() {
                            return portalApiGateway.get("/UserOnboarding/LoggedInUser");
                        };

                        service.getUserOnboardingById = function(onboardingId) {
                            return portalApiGateway.get("/UserOnboarding/" + onboardingId);
                        };

                        service.getUserOnboardingByArcAgentId = function (arcAgentId) {
                            return portalApiGateway.get("/UserOnboarding/ArcAgent/" + arcAgentId);
                        };

                        service.getContractingCompleted = function (arcAgentId) {
                            return portalApiGateway.get("/UserOnboarding/ContractingCompleted");
                        };

                        //posts                       
                        /*service.createUserOnboarding = function() {
                            return portalApiGateway.post("/UserOnboarding/");
                        };*/

                        service.updateContractingCompleted = function () {
                            return portalApiGateway.put("/UserOnboarding/Contracting/");
                        };

                        //puts
                        service.updateUserOnboarding = function() {
                            return portalApiGateway.put("/UserOnboarding/");
                        };

                        service.updateUsersArcInfo = function(arcUserInfo) {
                            return portalApiGateway.put("/UserOnboarding/ArcInfo", arcUserInfo);
                        };

                        //deletes
                        /*service.removeUserOnboarding = function () {
                            return portalApiGateway.delete("/UserOnboarding/Remove");
                        }  

                        service.removeUserOnboardingById = function (onboardingId) {
                            return portalApiGateway.delete("/UserOnboarding/Remove/" + onboardingId);
                        } */

                        return service;
                    }
                ];
            }
        ]);
})(window.app);